export default __webpack_public_path__ + "images/GrowingMoney.v-6101fbdaa69a05b9767fe1ff78c5d95e.png";